import { useCallback } from "react";
import { DEFAULT_SIGNUP_URL } from "../utils/urlConfig";

export function useLocationSearch() {
  const handleLocationSubmit = useCallback(
    (country: string, zipCode: string) => {
      window.location.href = `${DEFAULT_SIGNUP_URL}?c=${country}&sub=${zipCode}`;
    },
    [],
  );

  return { handleLocationSubmit };
}
